export const API_HOST = 'http://localhost:3000';
export const VOD_HOST = 'http://ssr.ruptly.online';
export const LIVE_HOST = 'http://live.ruptly.online';
export const STATIC_HOST = 'https://video.ruptly.tv';
export const STRIPE_API_KEY = 'pk_test_lDwsCASDrdL3ZKq9MqsFAuCD';
export const COMMON_DOMAIN = '.ruptly.tv';
export const WS_URI = "wss://api3.ruptly.tv/cable";
export const PLAUSIBLE_SCRIPT_PATH = 's3.eu-west-1.amazonaws.com/vodstorage.ruptly.online';
